"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKpiPopLabel = void 0;
var sdk_model_1 = require("@gooddata/sdk-model");
var granularityIntlCodes = {
    "GDC.time.date": "day",
    "GDC.time.week_us": "week",
    "GDC.time.month": "month",
    "GDC.time.quarter": "quarter",
    "GDC.time.year": "year",
};
var getGeneralKpiPopLabel = function (intl) {
    return intl.formatMessage({ id: "filters.allTime.previousPeriod" });
};
var getRelativeFilterKpiPopLabel = function (filter, intl) {
    var _a = sdk_model_1.relativeDateFilterValues(filter), from = _a.from, to = _a.to, granularity = _a.granularity;
    var intlGranularity = granularityIntlCodes[granularity];
    if (!intlGranularity) {
        return "";
    }
    return intl.formatMessage({ id: "filters." + intlGranularity + ".previousPeriod" }, { n: Math.abs(to - from) + 1 });
};
exports.getKpiPopLabel = function (filter, comparisonType, intl) {
    if (comparisonType === "lastYear") {
        // This string is meant to be the same no matter the filter
        return intl.formatMessage({ id: "filters.allTime.lastYear" });
    }
    if (sdk_model_1.isRelativeDateFilter(filter) && !sdk_model_1.isAllTimeDateFilter(filter)) {
        return getRelativeFilterKpiPopLabel(filter, intl);
    }
    return getGeneralKpiPopLabel(intl);
};
//# sourceMappingURL=translations.js.map